module.exports = __webpack_public_path__ + "media/images/flags/1x1/kgz-5b029b73542df289ddcbfd56845bfacc.svg";